(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOVue"), require("FEGOWebapi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOVue", "FEGOWebapi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-redpacket/render"] = factory(require("VueDemi"), require("FEGOVue"), require("FEGOWebapi"), require("FEGORender"));
	else
		root["/fego/component/common-redpacket/render"] = factory(root["VueDemi"], root["FEGOVue"], root["FEGOWebapi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__59906__, __WEBPACK_EXTERNAL_MODULE__29666__, __WEBPACK_EXTERNAL_MODULE__55113__, __WEBPACK_EXTERNAL_MODULE__85322__) => {
return 